import React, { isValidElement } from "react";
import styles from "./Panel.module.less";
import classnames from "classnames";
import { FormattedMessage } from "react-intl";
const Panel = ({ children, heading, className, ...rest }) => (<div className={classnames(styles.wrapper, className)} {...rest}>
		<div className={styles.header}>
			<h2 className="hdg">
				{heading != null && typeof heading === "object" && !isValidElement(heading) ? (<FormattedMessage {...heading}/>) : heading}
			</h2>
		</div>
		<div className={styles.content}>
			{children}
		</div>
	</div>);
export default Panel;



// WEBPACK FOOTER //
// ./src/assets/scripts/components/containers/secure/Account/Panel/Panel.tsx